import { render, staticRenderFns } from "./BibPartyPayment.vue?vue&type=template&id=65dc976e&scoped=true"
import script from "./BibPartyPayment.vue?vue&type=script&lang=js"
export * from "./BibPartyPayment.vue?vue&type=script&lang=js"
import style0 from "./BibPartyPayment.vue?vue&type=style&index=0&id=65dc976e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dc976e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsCustomQrCode: require('/app/components/Commons/CustomQrCode.vue').default})
